import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Chrome for every dashboard widget on both tabs. It fills whatever box the
 * grid gives it and its body scrolls inside itself, which is what keeps a long
 * list from ever making the page scroll.
 */
export function WidgetPanel({ title, meta, action, children, className, bodyClassName }: {
  title: string;
  meta?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
  bodyClassName?: string;
}) {
  return (
    <section className={cn("h-full min-h-0 bg-card border border-border rounded-lg flex flex-col overflow-hidden", className)}>
      <header className="flex items-center gap-2 px-3 py-1.5 border-b border-border/60 shrink-0 min-h-9">
        <h2 className="text-[11px] font-semibold uppercase tracking-[0.08em] text-muted-foreground whitespace-nowrap">{title}</h2>
        {meta !== undefined && <div className="text-xs text-muted-foreground tabular-nums truncate min-w-0">{meta}</div>}
        {action && <div className="ml-auto flex items-center gap-2 shrink-0">{action}</div>}
      </header>
      <div className={cn("flex-1 min-h-0 overflow-auto", bodyClassName)}>{children}</div>
    </section>
  );
}
